import {Pipe, PipeTransform} from '@angular/core';
import {Utilities} from '../utilities/utilities.model';

@Pipe({name: 'spaceDumper'})

export class SpaceDumperPipe implements PipeTransform {
    transform(value: number | string): string | null {
        if (!Utilities.isVoid(value)) {
            return value.toString().replace(/ /g, '');
        } else {
            return null;
        }
    }
}
